import { render, staticRenderFns } from "./CustomColorsScrollbarPage.vue?vue&type=template&id=7ed211c1&scoped=true&"
import script from "./CustomColorsScrollbarPage.vue?vue&type=script&lang=js&"
export * from "./CustomColorsScrollbarPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomColorsScrollbarPage.vue?vue&type=style&index=0&id=7ed211c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed211c1",
  null
  
)

export default component.exports